import { BaseRequestOptions, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { environment } from 'environments/environment';

/**
 * A middleware to provide a custom header on every request done with the HttpClient
 */
export class CustomRequestOptions extends BaseRequestOptions {
    headers = new Headers({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    });

    merge(options?: RequestOptionsArgs): RequestOptions {
        options.url = environment.BASE_PATH + options.url;
        const result = super.merge(options);
        result.merge = this.merge;
        return result;
    }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/base-app/custom-request-options.ts